var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDongle = function SvgIconDongle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_dongle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.293 6.11 2.627-2.626a.55.55 0 0 1 .78 0l4.603 4.603a.55.55 0 0 1 0 .779l-2.627 2.627zm-.832-.725 2.68-2.68a1.65 1.65 0 0 1 2.337 0l4.603 4.603a1.65 1.65 0 0 1 0 2.337l-2.68 2.68a2.204 2.204 0 0 1-.353 2.656l-5.372 5.372a6.535 6.535 0 0 1-9.242-9.242L8.806 5.74a2.204 2.204 0 0 1 2.655-.354m5.808 8.817-5.372 5.372a5.433 5.433 0 1 1-7.684-7.684l5.372-5.372c.43-.43 1.128-.43 1.558 0l6.126 6.126c.43.43.43 1.128 0 1.558m-2.736-7.256a.55.55 0 0 1 0-.78l1.155-1.154a.55.55 0 0 1 .779.779l-1.155 1.155a.55.55 0 0 1-.78 0m2.308 1.53a.55.55 0 0 0 .78.78L18.775 8.1a.55.55 0 1 0-.78-.779z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_dongle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .25h24v24H0z"
  })))));
};
export default SvgIconDongle;